'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _ModalWindow2 = require('./ModalWindow');

var _ModalWindow3 = _interopRequireDefault(_ModalWindow2);

var AlertWindow = (function (_ModalWindow) {
	_inherits(AlertWindow, _ModalWindow);

	function AlertWindow(title, text, style) {
		_classCallCheck(this, AlertWindow);

		_ModalWindow.call(this, title, text, null, style);
	}

	AlertWindow.prototype.show = function show(dispatch) {
		var _this = this;

		var modal = _react2['default'].createElement(
			_reactBootstrap.Modal,
			{ animation: false, show: true, onHide: function () {
					return _this.hide();
				}, bsStyle: this.style },
			_react2['default'].createElement(
				_reactBootstrap.Modal.Header,
				{ closeButton: true },
				_react2['default'].createElement(
					_reactBootstrap.Modal.Title,
					null,
					this.title
				)
			),
			_react2['default'].createElement(
				_reactBootstrap.Modal.Body,
				null,
				_react2['default'].createElement(
					'div',
					{ style: { padding: '20px 5px' } },
					this.text
				)
			),
			_react2['default'].createElement(
				_reactBootstrap.Modal.Footer,
				null,
				_react2['default'].createElement(
					_reactBootstrap.Button,
					{ onClick: function () {
							return _this.hide();
						}, bsStyle: 'primary' },
					'OK'
				)
			)
		);
		this.dispatch(dispatch, modal);
	};

	return AlertWindow;
})(_ModalWindow3['default']);

exports['default'] = AlertWindow;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-modal/src/AlertWindow.js
 ** module id = 1025
 ** module chunks = 1
 **/